import React from "react";

export const Email = ({hasUserName, handleUsername, renderErrorMessage, submitRegistration, username, qubeLite}) => {
    return <div className={"step flexRowContainer"} id="step1">
        <div>
            {!hasUserName && <div><h3 className={"mb10"}>Let's get started!</h3>
                Enter your email to get started!
                We'll send you a temporary link to resume the setup
                process if you get interrupted.</div>
            }
            {hasUserName && <h3 className={"mb10"}>Here's what we've got so far ...</h3>}
            <div className="flexRowContainer flexFill pt15 mt10">
                <input type="text" name="username" required className="fancyInput" value={username}
                       onChange={handleUsername} disabled={hasUserName}/>
                <label alt='Your email'
                       placeholder={hasUserName ? '' : 'Your email'}/>
            </div>
            {renderErrorMessage()}
            {!hasUserName && <div className={"flexColumnContainer"}>
                <div className={"flexFill"}/>
                <input type="button" className="btn setupBtn" value="Submit"
                       onClick={submitRegistration}/></div>}
            {hasUserName &&
            <b className={"signupSuccessColor"}><i className={"fas fa-check"}/> Email already
                provided</b>}

        </div>
    </div>
};